import { Ng2StateDeclaration } from '@uirouter/angular';

export const settings: Ng2StateDeclaration = {
  name: 'settings.**',
  url: '/settings',
  loadChildren: () => import('./root/settings.root.module').then(m => m.SettingsRootModule),
};
